export default {
  data() {
    return {
      isLoading: false,
      apiValidationErrors: {}
    };
  },
  methods: {
    /* extract API server validation errors and assigns them to local mixin data */
    setApiValidation(serverErrors) {
      this.apiValidationErrors = {"message": serverErrors.code_message}      
    },

    resetApiValidation() {
      this.apiValidationErrors = {};
    }
  }
};
